// Per-attempt id for the SFDC account lookup the API caches in Redis. It is not a credential: the API only
// reuses a cached lookup when its email matches the registration's email. It lives in sessionStorage (per tab,
// survives the redirect to login and back) and never holds SFDC data.
const KEY = "sfdcLookup";

const randomId = () => {
  const bytes = new Uint8Array(24);
  window.crypto.getRandomValues(bytes);
  // base64url, 32 chars
  return btoa(String.fromCharCode.apply(null, bytes))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};

const normalize = (email) => String(email || "").trim().toLowerCase();

// Starts a new lookup for this email and returns its id (or null if storage/crypto is unavailable).
export const startLookup = (email) => {
  try {
    const lookupId = randomId();
    window.sessionStorage.setItem(KEY, JSON.stringify({ lookupId, email: normalize(email) }));
    return lookupId;
  } catch (e) {
    return null;
  }
};

// The active lookup id, only when it was started for this email; otherwise undefined.
export const getLookupId = (email) => {
  try {
    const saved = JSON.parse(window.sessionStorage.getItem(KEY));
    if (saved && saved.lookupId && saved.email === normalize(email)) {
      return saved.lookupId;
    }
  } catch (e) {
    // ignore: no lookup id just means the API does a live lookup
  }
  return undefined;
};

// Call after a registration is accepted so the next registration starts a fresh lookup.
export const clearLookup = () => {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch (e) {
    // ignore
  }
};
